import { callUser } from '@/services/firebase/callable'

export default class AiChatHistoryService {
  static async listSessions({ limit = 20, cursor = null } = {}) {
    const { data } = await callUser('aiChatSessionsList', {
      limit,
      cursor
    })
    return {
      sessions: Array.isArray(data?.sessions) ? data.sessions : [],
      nextCursor: data?.nextCursor || null
    }
  }

  static async getSession({ sessionId, limit = 40, beforeMessageId = null } = {}) {
    const { data } = await callUser('aiChatSessionGet', {
      sessionId,
      limit,
      beforeMessageId
    })
    return {
      session: data?.session || null,
      messages: Array.isArray(data?.messages) ? data.messages : [],
      nextCursor: data?.nextCursor || null
    }
  }

  static async deleteSession(sessionId) {
    const { data } = await callUser('aiChatSessionDelete', { sessionId })
    return !!data?.ok
  }

  static async setSessionState({ sessionId, sessionState, personaId } = {}) {
    const { data } = await callUser('aiChatSessionStateSet', {
      sessionId,
      sessionState,
      personaId
    })
    return data?.session || null
  }

  static async cancelJob(jobId) {
    const { data } = await callUser('aiChatCancelJob', { jobId })
    return data || null
  }
}
